import type { Column, } from "devextreme/ui/data_grid";
import type { dxDateBoxOptions } from "devextreme/ui/date_box";

export const DEFAULT_DATETIME_FORMAT = "dd/MM/yyyy HH:mm:ss";
export function dateTimeDxItemProps(): dxDateBoxOptions { return { type: 'datetime', displayFormat: DEFAULT_DATETIME_FORMAT } };
export function dateTimeDxColumnProps(): Column { return { dataType: 'datetime', format: DEFAULT_DATETIME_FORMAT } };